module.exports = __webpack_public_path__ + "media/images/icon__externalLink@3x-3f6d67bb4c67c849c0251a11df64b76f.png";